/* eslint-disable react/prop-types */
import React from 'react';

var State = function State(_ref) {
  var state = _ref.state,
      Consumer = _ref.Consumer;
  return function (_ref2) {
    var children = _ref2.children,
        or = _ref2.or;
    return React.createElement(
      Consumer,
      null,
      function (value) {
        if (value[state]) {
          return typeof children === 'function' ? children(value) : children;
        }
        if (or) {
          var newOr = or;
          if (!Array.isArray(or)) {
            newOr = [or];
          }
          if (newOr.length === 0) return null;
          newOr = [].concat(newOr);
          var Component = newOr.shift();
          return Component({ children: children, or: newOr });
        }
        return null;
      }
    );
  };
};

export var Idle = function Idle(Consumer) {
  return State({ Consumer: Consumer, state: 'isIdle' });
};
export var Loading = function Loading(Consumer) {
  return State({ Consumer: Consumer, state: 'isLoading' });
};
export var Timeout = function Timeout(Consumer) {
  return State({ Consumer: Consumer, state: 'isTimeout' });
};
export var Success = function Success(Consumer) {
  return State({ Consumer: Consumer, state: 'isSuccess' });
};
export var Error = function Error(Consumer) {
  return State({ Consumer: Consumer, state: 'isError' });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-loads/es/LoadsStates.js
// module id = 1613
// module chunks = 0